module.exports = __webpack_public_path__ + "images/thumb-929aea664acbed2be4590633e02fa118.jpg";